import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTools, FaEnvelope, FaBullhorn, FaUsers, FaIdCard } from 'react-icons/fa';
import SEO from '../components/SEO';
import Marquee from '../components/Marquee';
import './Home.scss';
import { members as sharedMembers, Member } from '../data/members';
import gp1 from '../images/gp1.jpg';
import gp2 from '../images/gp2.jpg';
import gp3 from '../images/gp3.jpg';
import gp4 from '../images/gp4.jpg';
import gp5 from '../images/gp5.jpg';
import gp6 from '../images/gp6.jpg';
import gpb2 from '../images/gpb2.jpg';
import gpb3 from '../images/gpb3.jpg';
import gpb5 from '../images/gpb5.jpg';
import herobg from '../images/herobg.jpg';
import gptanda from '../images/gptanda.jpg';
import new1 from '../images/new1.jpg';
import new2 from '../images/new2.jpg';
import new3 from '../images/new3.jpg';
import news1 from '../images/news1.jpg';
import news2 from '../images/news2.jpg';
import gptandaVideo from '../videos/gptanda2.mp4';
import gptandaVideo2 from '../videos/gptanda1.mp4';
import gptandaVideo3 from '../videos/gptanda3.mp4';

const Home: React.FC = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Tanda Grampanchayat',
    description: 'तांडा ग्रामपंचायत - गोंदिया जिल्ह्यातील गोंदिया तालुक्यातील आधिकारिक ग्रामपंचायत',
    url: 'https://www.gptandagondia.org.in',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Tanda',
      addressLocality: 'Gondia',
      addressRegion: 'Gondia',
      postalCode: '441601',
      addressCountry: 'IN'
    },
    areaServed: 'Tanda, Gondia, Gondia',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      telephone: '+91-XXXXXXXXXX'
    }
  };

  // Hero background slider
  const heroImages = [herobg];
  const [heroIdx, setHeroIdx] = useState(0);
  const [autoPlay] = useState(true);

  useEffect(() => {
    if (!autoPlay) return;
    const interval = setInterval(() => setHeroIdx(i => (i + 1) % heroImages.length), 4000);
    return () => clearInterval(interval);
  }, [heroImages.length, autoPlay]);

  // Animated welcome text
  const welcomeText = 'तांडा ग्रामपंचायत मध्ये आपले स्वागत आहे';
  const [displayedText, setDisplayedText] = useState('');
  useEffect(() => {
    let idx = 0;
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText(welcomeText.slice(0, idx + 1));
      idx++;
      if (idx >= welcomeText.length) clearInterval(interval);
    }, 60);
    return () => clearInterval(interval);
  }, [welcomeText]);

  // About section toggle state
  const [showMoreAbout, setShowMoreAbout] = useState(false);

  // Ensure only one video plays at a time
  const handleVideoPlay = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    const current = e.currentTarget;
    const all = Array.from(document.querySelectorAll('video')) as HTMLVideoElement[];
    all.forEach(v => {
      if (v !== current && !v.paused) {
        v.pause();
      }
    });
  };

  // Pause videos when they scroll out of view (or mostly out)
  React.useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target as HTMLVideoElement;
          // If the video is not sufficiently visible, pause it
          if (!entry.isIntersecting || entry.intersectionRatio < 0.25) {
            if (!video.paused) {
              try {
                video.pause();
              } catch (err) {
                // ignore
              }
            }
          }
        });
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1] }
    );

    const videos = Array.from(document.querySelectorAll('video')) as HTMLVideoElement[];
    videos.forEach(v => observer.observe(v));

    return () => observer.disconnect();
  }, []);

  const [showCelebration, setShowCelebration] = useState(false);
  useEffect(() => {
    setShowCelebration(true);
    const id = window.setTimeout(() => setShowCelebration(false), 3000);
    return () => clearTimeout(id);
  }, []);

  return (
    <div className="home">
      {showCelebration && (
        <div className="celebration" aria-hidden>
          <div className="confetti-container" aria-hidden>
            {Array.from({ length: 40 }).map((_, i) => {
              const left = Math.random() * 100;
              const delay = Math.random() * 0.5;
              const duration = 2 + Math.random() * 1.5;
              const colorSet = ['#F97316', '#FFFFFF', '#16A34A', '#60A5FA', '#F472B6', '#FD7E14', '#FF6B6B'];
              const color = colorSet[i % colorSet.length];
              const size = 6 + Math.random() * 14;
              return (
                <div
                  key={i}
                  className="confetti-piece"
                  style={{
                    ['--left' as any]: `${left}%`,
                    ['--delay' as any]: `${delay}s`,
                    ['--duration' as any]: `${duration}s`,
                    backgroundColor: color,
                    width: `${size}px`,
                    height: `${size}px`
                  }}
                />
              );
            })}
          </div>

          <div className="sparkles-container" aria-hidden>
            {Array.from({ length: 12 }).map((_, i) => {
              const left = Math.random() * 100;
              const delay = Math.random() * 0.3;
              return (
                <div
                  key={i}
                  className="sparkle"
                  style={{
                    ['--left' as any]: `${left}%`,
                    ['--delay' as any]: `${delay}s`
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
      {/* Maharashtra Government Banner */}
      <div className="govt-banner">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Seal_of_Maharashtra.png/80px-Seal_of_Maharashtra.png" alt="महाराष्ट्र शासन" className="govt-emblem" />
        <span className="govt-text">महाराष्ट्र शासन</span>
      </div>

      {/* Latest Update Marquee */}
      <Marquee
        text="पावसाळ्याआधी रस्त्यांची दुरुस्ती केली जाणार आहे | विद्यार्थ्यांसाठी शिष्यवृत्ती योजना अंतर्गत अर्ज मागण्यात येत आहेत | हर घर नलजल योजना सुरू आहे"
        speed={25}
      />

      <SEO
        title="तांडा ग्रामपंचायत | Tanda Grampanchayat - आधिकारिक वेबसाइट"
        description="तांडा ग्रामपंचायत - गोंदिया जिल्ह्यातील गोंदिया तालुक्यातील आधिकारिक ग्रामपंचायत वेबसाइट। सेवा, जाहिराती, नेतृत्व आणि ग्रामीण विकास कार्यक्रम।"
        keywords="तांडा, ग्रामपंचायत, गोंदिया, महाराष्ट्र, गोंदिया, सरपंच, ग्रामीण विकास, सेवा"
        ogTitle="तांडा ग्रामपंचायत | Tanda Grampanchayat"
        ogDescription="तांडा ग्रामपंचायत - आधिकारिक ग्रामपंचायत वेबसाइट"
        canonicalUrl="https://gptandagondia.org.in"
        structuredData={structuredData}
      />
      {/* Hero Section with animated slider and text */}
      <section className="hero" style={{ backgroundImage: `url(${heroImages[heroIdx]})`, backgroundSize: 'cover', backgroundPosition: 'center', transition: 'background-image 1s' }}>
        <div className="hero-content" style={{ background: 'rgba(0,0,0,0.45)', borderRadius: '18px', padding: '2rem' }}>
          <h1 style={{ minHeight: 48, fontWeight: 700, letterSpacing: 1 }}>{displayedText}<span className="blinking-cursor">|</span></h1>
          <p style={{ fontSize: '1.5rem', fontWeight: 500, marginBottom: 24 }}>सर्वांसाठी, सर्वांच्या विकासासाठी</p>
          <div className="cta-buttons">
            <Link to="/services" className="btn btn-primary">आमच्या सेवा</Link>
            {/* <Link to="/contact" className="btn btn-secondary">संपर्क साधा</Link> */}
          </div>
        </div>
      </section>

      {/* Stats/Counters Section */}
      {/* <section className="stats-section">
        <div className="container stats-grid">
          {stats.map((stat, i) => (
            <div className="stat-card" key={stat.label}>
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-value">{counts[i]}<span className="stat-plus">{stat.value > 10 ? '+' : ''}</span></div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section> */}
      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="section-header">
            <h2>ग्रामपंचायत कार्यालय तांडा</h2>
            <h4>पं.स.गोंदिया ता. – गोंदिया , जिल्‍हा परिषद .-गोंदिया, महाराष्ट्र</h4>
            <p>प्रस्तावना </p>
          </div>
          <div className="about-content">
            <div className="about-text">
              <p>
                मुख्यमंत्री समृध्द पंचायत राज अभियान अंतर्गत ग्रामपंचायत कार्यालय तांडा याची स्थापना सन १९५२ ला झालेली आहे. आमच्या तांडा या गावाचे प्रथम सरपंच श्री भोजराजसिंह गणपतसिंह सोमवंशी हे सन १९५३ ते १९५७ पर्यंत  गावाचे प्रथम सरपंच होते तेव्हापासून आमचा तांडा हे गाव सतत विकासाच्या वाटेने वाटचाल करीत आहे आता पर्यंत  गावात एकूण १८ सरपंच झालेले आहेत सध्या स्थितीत १९ वे सरपंच सौ.वर्षाताई दीपक पटले  व उपसरपंच श्री निलेस्वर  तेजरामजी कारंजेकर व इतर ०८ सदस्य १०/०१/२०२३ पासून कार्यरत आहेत.
                तांडा हे गाव गोंदिया ते आमगाव (NH -५४३ ) महामार्गावर वसलेले गाव आहे या गावाचे भौगोलिक क्षेत्र ६६४.४२ आहे या गावाची लोकसंख्या २०११ च्या जणगणनेनुसार २७८२ असून  अनुसूचित जाती २५८ ,अनुसूचित जमाती २०५ व ईतर २३१९ अशी आहे. या गावाचे  शिवाटोला,सावकारटोली व गोंडीटोला हे तीन प्रमुख टोले आहेत.या गावात क्रमांक  १,२  व ३  अंगणवाडी आहेत आणि जि.प. वरिष्ठ प्राथमिक शाळा  तांडा येथे  कॉन्वेट व १ ते ७ पर्यंत वर्ग खोल्या आहेत. व यात एकूण १७० विद्यार्थी शिक्षण घेत आहेत  जिल्हापरिषद शाळेचा आवारातमुलाकरिता व्यायाम शाळा   भव्य मोठा पंटागण आहे व यात एकूण २७० झाडे लावलेले आहेत. या गावात स्व पोहुमल हायस्कूल व बी एस सी नर्सिंग कॉलेज उपलब्ध आहे तसेच स्व.खुशाल कापसे कनिष्ट महाविधालय येथे ११ ते  पदवी पर्यंत शिक्षण उपलब्ध आहे.
              </p>
              {showMoreAbout && (
                <p>
                  या गावात महिला बचत गट भवन,वाचनालय अशा एकूण ०८ शासकीय ईमारती आहेत तसेच गावात  एकूण १४ चौक व ०३ वार्ड  आहेत  तसेच गावामध्ये पोळा,गोवर्धन चौक व मंडई ची जागा राखून ठेवलेली आहे.या गावाची परंपरा आहे कि संपूर्ण गावातील लोक गावाच्या विकासाकरिता मिळून प्रयत्न करतात व सार्वजनिक उत्सव जसे कि पोळा , गणेशउत्सव,दुर्गाउत्सव, दसरा,दिवाळी, महाशिवरात्री ,होळी,बिरसा मुंडा जयंती  मोठ्या उत्साहाने साजरे करतात व सार्वजनिक ठिकाणी भजन कीर्तनाच्या माध्यमातून  बालविवाह,हुंडा प्रतिबंध कायदा अंधश्रद्धा निर्मुलन ,वेशन मुक्ती,ग्रामस्वच्छता, प्लास्टिक बंदी समाजप्रबोधन व संत पुण्यतिथी इत्यादी विषयावर भजन मंडळाच्या माध्यमातून जनजागृती केली जाते व प्रत्येक आठवड्यात रविवार या दिवशी ग्रामस्वच्छता संघाव्दारे स्वच्छतेचे कार्य केले जाते तसेच गावामध्ये एकूण ०७ तळे सार्वजनिक पाण्याची टाकी सध्या तांडा या गावात माळयादेव देवस्थान पर्यटन स्थळ महणून विकसित होत आहे महाशिवरात्रीला माळयादेव येथे ८० ते ९० वर्षापासून जत्रा भरत असते व आजूबाजूच्या परिसरातील लोक येतात व आपला आनद द्वूगुनीत करतात.
                  या गावातील लोकांना पिण्याकारिता शुध्द पाणी  वाटर एटीएम  व्दारे उपलब्ध करण्यात  आले आहे. गावातजलजीवन मिशन प्राधिकरण अंतर्गत  हर घर नलजल  योजना उपलब्ध करण्यात आली आहे तसेच गावामध्ये वाटर टँकर,लघु नळ योजना,बंदिस्त गटारे, स्मशान भूमी,व स्मशानभूमी स्थळी सिमेंट खुर्च्या,मग्रारोहयो व मझी वसुंधरा योजने अंतर्गत झाले लावलेले आहेत सिमेंट रस्ते सुव्यवस्थित आहेत व या गावात दळणवळणा करिता गोंदिया  हे त.जिल्हाचे ठिकाण अंदाजे ९ ते १० कि.मी अंतरावर आहे
                </p>
              )}
              <button
                onClick={() => setShowMoreAbout(!showMoreAbout)}
                className="btn btn-outline"
                style={{ marginTop: '1rem' }}
              >
                {showMoreAbout ? 'कमी दाखवा' : 'अधिक जाणून घ्या'}
              </button>
            </div>
            <div className="about-image">
              <img src={gptanda} alt="गाव विकास कार्यक्रम" />
              {/* {src: gp1, title: 'गाव विकास कार्यक्रम' } */}
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2>आमच्या सेवा</h2>
            <p>आम्ही तुम्हाला पुरवत असलेल्या सेवा</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <FaTools />
              </div>
              <h3>रस्ते आणि वाहतूक</h3>
              <p>गावातील रस्त्यांची देखभाल आणि वाहतूक सुविधा</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <FaEnvelope />
              </div>
              <h3>पाणी पुरवठा</h3>
              <p>स्वच्छ पाण्याची पुरवठा व्यवस्था</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <FaBullhorn />
              </div>
              <h3>स्वच्छता अभियान</h3>
              <p>स्वच्छता आणि आरोग्याबाबत जागरूकता</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <FaUsers />
              </div>
              <h3>कल्याणकारी योजना</h3>
              <p>सरकारी योजनांचा लाभ</p>
            </div>
          </div>
          <div className="text-center">
            <Link to="/services" className="btn btn-primary">सर्व सेवा पहा</Link>
          </div>
        </div>
      </section>

      {/* Announcements */}
      <section className="announcements">
        <div className="container">
          <div className="section-header">
            <h2>जाहिराती</h2>
            <p>नवीन आणि महत्वाच्या जाहिराती</p>
          </div>
          <div className="announcement-list">
            <div className="announcement announcement-video-only">
              <div className="announcement-header">
                <div className="announcement-date">१७/०९/२०२५</div>
                <h3>मुख्यमंत्री समृद्ध पंचायतराज अभियान राबविण्यासंदर्भात प्रचार प्रसिद्धी</h3>
              </div>
              <div className="announcement-video-full">
                <video
                  controls
                  width="100%"
                  height="100%"
                  disablePictureInPicture
                  controlsList="nodownload noplaybackrate noremoteplayback"
                  onContextMenu={(e) => e.preventDefault()}
                  onPlay={handleVideoPlay}
                >
                  <source src={gptandaVideo} type="video/mp4" />
                </video>
              </div>
              <p style={{ marginTop: '1.5rem', color: 'var(--gray-color)', lineHeight: '1.7' }}>
                दिनांक १७/०९/२०२५ रोज बुधवारला सकाळी ठिक १०:०० वाजता ग्रामपंचायत कार्यालय तांडा येथे मुख्यमंत्री समृद्ध पंचायतराज अभियान राबविण्यासंदर्भात कार्यक्रम घेण्यात आले.सर्व प्रथम अभियानाचा राज्यस्तरीय सुभारंभ  कार्यक्रम प्रक्षेपण उपस्थित सर्वान्ना लाइव कार्यक्रम दाखविण्यात आले .व त्यानंतर विशेष ग्रामसभेला मा.सरपंच श्रीमती सौ. वर्षा दिपक पटले यांच्या अध्यक्षतेखाली  सुरुवात करण्यात आली .
              </p>
            </div>
            <div className="announcement announcement-video-only">
              <div className="announcement-header">
                <div className="announcement-date">२५/१०/२०२५</div>
                <h3>ग्रामस्वच्छता आणि जनजागृती मोहिम</h3>
              </div>
              <div className="announcement-video-full">
                <video
                  controls
                  width="100%"
                  height="100%"
                  disablePictureInPicture
                  controlsList="nodownload noplaybackrate noremoteplayback"
                  onContextMenu={(e) => e.preventDefault()}
                  onPlay={handleVideoPlay}
                >
                  <source src={gptandaVideo2} type="video/mp4" />
                </video>
              </div>
              <p style={{ marginTop: '1.5rem', color: 'var(--gray-color)', lineHeight: '1.7' }}>
                ग्रामस्वच्छता मोहिमेअंतर्गत गावामध्ये स्वच्छता, प्लास्टिक वापरबंदी, कचरा व्यवस्थापन आणि आरोग्य जनजागृतीबाबत कार्यक्रम आयोजित करण्यात आले. ग्रामस्थांचा उत्स्फूर्त सहभाग नोंदवला गेला.
              </p>
            </div>

            <div className="announcement announcement-video-only">
              <div className="announcement-header">
                <div className="announcement-date">१०/११/२०२५</div>
                <h3> भव्य निःशुल्क आरोग्य शिबिर कार्यक्रम</h3>
              </div>
              <div className="announcement-video-full">
                <video
                  controls
                  width="100%"
                  height="100%"
                  disablePictureInPicture
                  controlsList="nodownload noplaybackrate noremoteplayback"
                  onContextMenu={(e) => e.preventDefault()}
                  onPlay={handleVideoPlay}
                >
                  <source src={gptandaVideo3} type="video/mp4" />
                </video>
              </div>
              <p style={{ marginTop: '1.5rem', color: 'var(--gray-color)', lineHeight: '1.7' }}>
                मुख्यमंत्री समृद्ध पंचायतराज अभियान कार्यक्रम अंतर्गत ग्राम पंचायत कार्यालय तांडा , व पं.समिती गोंदिया  अतंर्गत माय बहुउद्देशीय विकास सेवा संस्था द्वारा भव्य निःशुल्क आरोग्य शिबिर कार्यक्रम दिनांक १०/११/२०२५ रोज सोमवारला आयोजित करण्यात आले होते.सदर कार्यक्रमाचे अध्यक्ष मा. सौ. वर्षा दीपक पटेले सरपंच ग्राम पंचायत तांडा तसेच उद्घाटक मा. श्री. मुनेश जगन्नाथ रहांगडाले सभापती पंचायत सभापती गोंदिया तसेच मा. श्री निलेश्वरजी कारंजेकर उपसरपंच तसेच श्री.रामेश्वर जी भगत ग्रा. पं.सदस्य, श्री रमेशजी उके ग्रा.पं.सदस्य, व कु. साधना टेकचंद बिसेन ग्रा.पं.अधिकारी त्याचप्रमाणे श्री डी. एस. पटले सर (मुख्याध्यापक वरिष्ठ जी.परिषद शाळा तांडा) श्री. एस. एन टेंभेकर सर शिक्षक, त्याचप्रमाणे श्री डॉ.दीपक पटले तांडा सामाजिक कार्यकर्ता श्री.खेमराज पुंडे अध्यक्ष माजी तंटा.मु.समिती तांडा,श्री अजय पटले  अध्यक्ष माय बहुउद्देशीय विकास सेवा संस्था द्वारे आरोग्य सेवेची धुरा मा. श्री डॉ.एल.एल.बजाज ,मा.श्री.धीरज परिहार, मा.डॉ.शेख, डॉ. स्वरूप बिसेन, डॉ. व्यंकटेश माहूरे, डॉ. कृष्णकुमारी जगणे, डॉ. अल्का मेंढे आदींनी १०० ते १५० गावातील  लोकांचे आरोग्य तपासणी निःशुल्क केली.तसेच शालेय विद्यार्थ्यांची तपासणी करण्यात आली              </p>
            </div>

            <div className="announcement announcement-video-only">
              <div className="announcement-header">
                <div className="announcement-date">०९/११/२०२५</div>
                <h3> महिला बचत गट लघुउद्योग प्रशिक्षण</h3>
              </div>
              <div className="announcement-video-full">
                <img src={new2} alt="" />
              </div>
              <p style={{ marginTop: '1.5rem', color: 'var(--gray-color)', lineHeight: '1.7' }}>
                मुख्यमंत्री पंचायतराज अभियान अंतर्गत ग्रामपंचायत तांडा येथे दिनांक ०९/११/२०२५  ला महिला बचत गट लघुउद्योग प्रशिक्षण आयोजित करण्यात आले. सदर प्रशिक्षण मध्ये कुक्कुटपालन, शेळीपालन, चंदन लागवड, मोहगनी वृक्ष लागवड, गांडूळ खत प्रकल्प, कपासाची बत्ती रोजगार, अगरबत्ती बनवण्यावरील रोजगार,फळबाग लागवडी बाबत, भाजीपाला लागवडी संदर्भात रीतसर माहिती सदर प्रशिक्षणा त हेमंत पटले सर ट्रेनर भंडारा यांनी दिली तसेच कौशल्य प्रशिक्षणामध्ये छाया रहांगडाले मॅडम यांनी ब्युटी पार्लर बाबद माहिती तसेच बचत गटांच्या महिलांना प्रात्यक्षिक करून दाखवले.ग्राम तांडा येथील समस्त महिला बचत गटातील संपूर्ण महिला, प्रशिक्षण यशस्वीरित्या घेऊन आपल्या दैनंदिन जीवनात त्याचा उपयोग होईल. सदर कार्यक्रमा चे अध्यक्ष सौ.वर्षा दीपक पटले, कार्यक्रमाचे उद्घाटक महोदय पंचायत समिती गोंदिया चे सभापती श्री मुनेश जी रहांगडाले  सर तसेच ग्रामपंचायत तांडा चे उपसरपंच निलेश्वरजी कारंजेकर , ग्रा.पं.स. रामेश्वरजी भगत, जितेंद्र जी  बिसेन, ग्रामपंचायत अधिकारी कु. साधना ‌ बिसेन ,प्रमुख पाहुणे म्हणून उपस्थित सेवा संस्था अध्यक्ष अजय पटले जी , डॉक्टर दीपक जी पटले , ओमचंदजी रहांगडाले , प्यारेलालजी रहांगडाले ग्रामपंचायत कर्मचारी. दीपक जी बावणे ग्रामपंचायत कर्मचारी. महेश कटरे ऑपरेटर , तसेच गावातील समस्त गावकरी ग्रामस्थ यांच्या प्रमुख उपस्थितीमध्ये सदर कार्यक्रम आयोजित करण्यात आले. व सदर कार्यक्रम यशस्वीरित्या पार पाडण्यात आले</p>
            </div>

            <div className="announcement announcement-video-only">
              <div className="announcement-header">
                <div className="announcement-date">१२/११/२०२५</div>
                <h3> गोंडीटोला (तांडा) येथे नाल्यावरती वनराई बंधारा बांधण्यात आला</h3>
              </div>
              <div className="announcement-video-full">
                <img src={gpb5} alt="" />
              </div>
              <p style={{ marginTop: '1.5rem', color: 'var(--gray-color)', lineHeight: '1.7' }}>
                मुख्यमंत्री समृद्ध पंचायतराज अभियान कार्यक्रमाअंतर्गत आज दिनांक १२/११/२०२५ ला गोंडीटोला (तांडा) येथे नाल्यावरती वनराई बंधारा बांधण्यात आला नाल्यास्थळी ग्राम पंचायत कार्यालय तांडा येथील  सौ. वर्षाताई दिपक पटले (सरपंच), श्री निलेश्वरजी तेजराम कारंजेकर (उपसरपंच), श्री रामेश्वर नारायणजी भगत (सदस्य) सौ लताताई अशोकसिंह पवार (सदस्या), कु.एस.टी.बिसेन (ग्रा.पं.अधिकारी), श्री ओमचंदजी रहांगडाले (रो.सेवक ) श्री. एस.एन.टेंभेकर सर (शिक्षक जि.प.वरिष्ठ प्राथमिक शाळा तांडा) श्री. देवचंद महादेवजी हरिणखेडे (अध्यक्ष शाळा व्यवस्थापन समिती तांडा) श्री अशोकसिंह जी पवार (माजी अध्यक्ष शाळा व्यवस्थापन समिती तांडा)श्री. राजेंद्रजी रहांगडाले (मजूर मेट) श्री खुमेंद्र ओमचंदजी बिसेन (मजूर मेट) ग्राम पंचायत कर्मचारी तसेच गावातील समस्थ उपस्थित नागरिक यांच्या सहकार्याने वनराई बंधारा बांधण्यात आले                </p>
            </div>


          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery">
        <div className="container">
          <div className="section-header">
            <h2>गॅलरी</h2>
            <p>गावातील कार्यक्रम आणि विकास प्रकल्प</p>
          </div>
          <div className="gallery-grid">
            {[{ src: gp1, title: 'ग्रामपंचायत कार्यालय' },
              { src: gp2, title: 'स्वच्छता अभियान' },
              { src: gp3, title: 'सौर ऊर्जा कार्यक्रम' },
              { src: gp4, title: 'मुख्यमंत्री अभियान' },
              { src: gp5, title: 'प्रशासनिक सभा' },
              { src: gp6, title: 'ग्राम विकास कार्यक्रम' },
              { src: gpb2, title: 'आरोग्य शिबिर' },
              { src: gpb3, title: 'स्त्री कल्याण कार्यक्रम' },
              { src: gpb5, title: 'नाल्याच्या बांधकामाचे काम' },
              { src: news1, title: 'निःशुल्क आरोग्य शिबिर' },
              { src: news2, title: 'समाजिक उपक्रम' },
              { src: new3, title: 'महिला बचत गट' },
              { src: new2, title: 'गाव विकास कार्यक्रम' },
              { src: new1, title: 'शिक्षा कार्यक्रम' },
              { src: gptanda, title: 'ग्राम कामकाज' }
            ].map((img, idx) => (
              <div className="gallery-item" key={idx}>
                <img src={img.src} alt={img.title} />
                <div className="gallery-overlay">
                  <h3>{img.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Executive Committee Section */}
      <section className="exec-committee">
        <div className="container">
          <div className="panel">
            <h2>ग्रामपंचायत कार्यकारणी मंडळ</h2>
            <div className="diamond" />
            <ul className="member-grid">
              {sharedMembers.map((m: Member) => (
                <li key={m.id} className="member-item">
                  <div className="icon" aria-hidden>
                    <FaIdCard />
                  </div>
                  <div className="info">
                    <div className="name">{m.name}</div>
                    <div className="role">{m.role}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
